import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import "aos/dist/aos.css";
// import sass
import "../sass/app.scss";

import AOS from "aos";

//redux
import { Provider, connect } from "react-redux";
import store from "./redux/store";
import { resizeWindow } from "./redux/actions/layoutActions";
import { logout } from "./redux/actions/authActions";

import { nthIndex } from "./helperFunctions/functions";
import {
  setStorage,
  getStorage,
  checkStorage,
  deleteStorage,
} from "./helperComponents/locale-storage";

import { Show422ErrorMessage } from "./helperFunctions/functions";
import axios from "./helperComponents/axios";
import { notification, message, ConfigProvider } from "antd";

// Containers
const DefaultLayout = React.lazy(() => import("./layout"));
// Pages
const Login = React.lazy(() => import("./views/login"));

const loading = () => (
  <div className="animated fadeIn pt-3 text-center font-Xlarge text-theme-color">
    <LoadingOutlined />
  </div>
);

class Main extends Component {
  componentDidMount() {
    window.onresize = () => {
      this.props.resizeWindow(window.innerWidth);
    };
    this.activateAOS();
  }
  activateAOS() {
    AOS.init({
      easing: "ease-out-back",
      offset: 0,
      duration: 700,
      once: true,
    });
  }

  UNSAFE_componentWillReceiveProps(props) {
    var hours = 1; // Reset when last action is more than an hour
    var now = new Date().getTime();
    var setupTime = parseInt(localStorage.getItem("setupTime"));

    if (setupTime == null) {
      props.logout();
      localStorage.setItem("setupTime", now);
    } else {
      if (now - setupTime > hours * 60 * 60 * 1000) {
        deleteStorage("setupTime");
        props.logout();
      } else {
        localStorage.setItem("setupTime", now);
      }
    }
  }

  UNSAFE_componentWillMount() {
    axios.interceptors.response.use(
      (res) => {
        if (res.data.message) {
          message.destroy();
          message.success(res.data.message);
        }
        return res;
      },
      (error) => {
        var serverError = false;
        notification.destroy();
        if (error.response) {
          if (error.response.status == 401) {
            this.props.logout();
          }
          if (error.response.status) {
            if (error.response.status == 422) {
              Show422ErrorMessage(error.response.data.errors);
              // notification.error({
              //   message: 'بيانات غير صحيحة',
              // });
            } else if (error.response.status == 403) {
              notification.error({
                message: "عمل غير مصرح به",
              });
            } else if (error.response.status == 429) {
              notification.error({
                message: "طلبات كثيرة جدا",
              });
            } else if (error.response.status == 401) {
              notification.error({
                message: "غير مصدق",
              });
            } else if (error.response.status == 500) {
              notification.error({
                message: "خطأ في الخادم",
              });
            } else if (error.response.status == 503) {
              notification.error({
                message: "الخدمة غير متوفرة",
              });
            } else if (error.response.status == 404) {
              notification.error({
                message: "غير موجود",
              });
            } else {
              notification.error({
                message: "خطأ في الخادم",
              });
            }
          }
        } else {
          serverError = true;
        }
        if (serverError) {
          notification.error({
            message: "خطأ في الإتصال",
          });
        }
        return Promise.reject(error);
      }
    );
  }

  render() {
    const website_keys = {
      contraction: "satc_contracting",
      equipments: "satc_equipments",
      public: "satc_public",
    };
    const { is_logged, login_token } = this.props;
    if (login_token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${login_token}`;
    }

    // check if url has a right prefix
    const { company_type } = this.props.match.params;
    const { location } = this.props;
    if (
      !company_type ||
      ["contraction", "equipments", "public"].indexOf(
        company_type.toLowerCase()
      ) === -1
    ) {
      var prefix = "contraction";
      if (is_logged == "true" && prefix) {
        return (
          <Redirect to={`/${prefix}${location.pathname}${location.search}`} />
        );
      }
    }
    if (is_logged == "true" && company_type) {
      axios.defaults.headers.common["WEBSITE-KEY"] = website_keys[company_type];
    } else {
      axios.defaults.headers.common["WEBSITE-KEY"] =
        website_keys.contraction;
    }
    return (
      <React.Suspense fallback={loading()}>
        <Switch>
          <Route
            path="/login/:redirect?"
            render={(props) =>
              is_logged != "true" ? (
                <Login {...props} />
              ) : (
                <React.Fragment>
                  <Redirect to={`/`} />
                </React.Fragment>
              )
            }
          />

          <Route
            path={`/`}
            render={(props) =>
              is_logged == "true" ? (
                <React.Fragment>
                  <Route
                    path="/"
                    name="Home"
                    render={(props) => (
                      <DefaultLayout {...props} company_type={company_type} />
                    )}
                  />
                </React.Fragment>
              ) : (
                <Redirect
                  to={`/login/${props.location.pathname.substring(
                    nthIndex(props.location.pathname, "/", 1) + 1,
                    props.location.pathname.length
                  )}${props.location.search}`}
                />
              )
            }
          />
        </Switch>
      </React.Suspense>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const mapStateToProps = (state) => ({
      login_token: state.auth.login_token,
      is_logged: state.auth.is_logged,
      user_type: state.auth.user_type,
    });
    const MainCompenent = connect(mapStateToProps, { resizeWindow, logout })(
      Main
    );
    return (
      <React.Fragment>
        <Provider store={store}>
          <ConfigProvider direction="rtl">
            <Router>
              <Route
                path="/:company_type?"
                render={(props) => <MainCompenent {...props} />}
              />
            </Router>
          </ConfigProvider>
        </Provider>
      </React.Fragment>
    );
  }
}

export default App;
